<template>
  <div class="batch-issues" v-if="sorted.length > 0">
    <div class="batch-issue" v-for="(issue, index) in visible" :key="index"
         :class="`is-${issue.level}`">
      <fa-icon class="batch-issue-icon" :class="`is-${issue.level}`"
               :icon="['fal', iconOf(issue)]"/>
      <div class="batch-issue-text">
        <b>{{ issue.message }}</b>
        <small v-if="issue.detail">{{ issue.detail }}</small>
      </div>
      <button class="btn btn-sm btn-gray" v-if="issue.action"
              @click="$emit('action', issue)">{{ issue.action.label }}</button>
    </div>
    <a href="#" class="batch-issues-more" v-if="sorted.length > visible.length"
       @click.prevent="expanded = true">
      e mais {{ sorted.length - visible.length }}
    </a>
  </div>
  <div class="batch-issues-ok" v-else>
    <fa-icon :icon="['fal', 'check-circle']"/>
    {{ okMessage }}
  </div>
</template>

<script>
const ORDER = { block: 0, warn: 1, info: 2 };

export default {
  props: {
    issues: {
      type: Array,
      default: () => [],
    },
    okMessage: {
      type: String,
      default: 'Sem pendências · pronto para gerar o XML',
    },
    limit: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    sorted() {
      return [...this.issues].sort((a, b) => (ORDER[a.level] ?? 9) - (ORDER[b.level] ?? 9));
    },
    visible() {
      return this.expanded ? this.sorted : this.sorted.slice(0, this.limit);
    },
  },
  methods: {
    iconOf(issue) {
      if (issue.level === 'block') return 'exclamation-circle';
      if (issue.level === 'warn') return 'exclamation-triangle';
      return 'info-circle';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
$amber-bg: #FFF8E6;
$amber-border: #F2C94C;
$amber-text: #8A6D1F;

.batch-issues {
  display: flex;
  flex-wrap: wrap;
  gap: $layout-spacing;
  margin-top: $layout-spacing-lg;
  .batch-issue {
    align-items: center;
    background-color: $amber-bg;
    border: $amber-border solid $border-width;
    border-radius: $border-radius;
    display: flex;
    flex: 1 1 18rem;
    font-size: $font-size-sm;
    gap: .4rem;
    padding: $layout-spacing-sm $layout-spacing;
    .batch-issue-icon {
      flex: 0 0 auto;
      &.is-block {
        color: darken($error-color, 8%);
      }
      &.is-warn {
        color: darken($warning-color, 22%);
      }
      &.is-info {
        color: $info-color;
      }
    }
    .batch-issue-text {
      flex: 1 1 auto;
      min-width: 0;
      b {
        color: $gray-color-900;
        font-weight: 600;
      }
      small {
        color: $gray-color-dark;
        &::before {
          content: ' · ';
        }
      }
    }
    &.is-block {
      border-color: lighten($error-color, 30%);
      background-color: lighten($error-color, 40%);
    }
    .btn {
      flex: 0 0 auto;
    }
  }
  .batch-issues-more {
    align-self: center;
    font-size: $font-size-xs;
    &:focus {
      box-shadow: none;
    }
  }
}
.batch-issues-ok {
  align-items: center;
  background-color: #F2FAF5;
  border: #BFE3CD solid $border-width;
  border-radius: $border-radius;
  color: #1F7A4E;
  display: flex;
  font-size: $font-size-sm;
  gap: .3rem;
  padding: $layout-spacing $layout-spacing-lg;
}
</style>
